import styled from 'styled-components';
import { BHS_VERDE } from 'constants/cores';

export const HeaderWrapper = styled.header`
  width: 90%;
  max-width: 1250px;
  margin: 0 auto;
  padding: 16px 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;

  background-color: #fcfdff;

  img {
    height: 28px;
    width: auto;
  }

  h2 {
    margin: 0;
    align-self: center;

    color: ${BHS_VERDE};
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }
`;
